import {
    SET_ASIDE_BAR_HAS_CHANGED,
    SET_DESTINATION_ITEM,
    SET_ORGANIZATION_TREE_ITEMS,
    SET_ORGANIZATION_TREE_PLACEHOLDER,
    SET_PREV_ORGANIZATION_TREE_ITEMS,
    SET_PREV_ORGANIZATION_TREE_PLACEHOLDER,
    SET_SOURCE_ITEM,
    SET_LATEST_FULL_TREE,
    SET_IS_SEARCH_ACTIVE
} from '@/store/modules/organizationTree/mutations'

const setOrganizationTreeItems = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_TREE_ITEMS, payload)
}

const setOrganizationTreePlaceholder = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_TREE_PLACEHOLDER, payload)
}

const setPrevOrganizationTreeItems = ({ commit }, payload) => {
    commit(SET_PREV_ORGANIZATION_TREE_ITEMS, payload)
}

const setPrevOrganizationTreePlaceholder = ({ commit }, payload) => {
    commit(SET_PREV_ORGANIZATION_TREE_PLACEHOLDER, payload)
}

const setSourceItem = ({ commit }, payload) => {
    commit(SET_SOURCE_ITEM, payload)
}

const setDestinationItem = ({ commit }, payload) => {
    commit(SET_DESTINATION_ITEM, payload)
}

const setAsideBarHasChanged = ({ commit }, payload) => {
    commit(SET_ASIDE_BAR_HAS_CHANGED, payload)
}

const setLatestFullTree = ({ commit }, payload) => {
    commit(SET_LATEST_FULL_TREE, payload)
}

const setIsSearchActive = ({ commit }, payload) => {
    commit(SET_IS_SEARCH_ACTIVE, payload)
}

export default {
    setOrganizationTreeItems,
    setOrganizationTreePlaceholder,
    setSourceItem,
    setDestinationItem,
    setPrevOrganizationTreeItems,
    setPrevOrganizationTreePlaceholder,
    setAsideBarHasChanged,
    setLatestFullTree,
    setIsSearchActive
}
